import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useOutletContext } from "react-router-dom";
import TableData from "./TableData";


export default function ProfileCollection(props) {
    const [menu, menuopen] = useOutletContext();
    useEffect(()=>{
        menu(false)
    },[menu])
    const [page,setPage]  =  useState(props.data);
    
    return (
        <>
        <Row>
        <Col lg={12} className="mb-4">
           <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
           <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i>  Collection View</h1>
           <Link to={'../collection/createcollection'} className="btn btn-secondary fw-semibold text-white addBtns"><i className="fa-light fa-plus"></i> <span>Create New Collection</span></Link>
           </div>
        </Col>
        </Row>
        <TableData data={page} />
        </>
    )
}